import {Component, OnInit} from '@angular/core';
import {AfterViewInit, OnDestroy, ViewChild} from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import {DataTableDirective} from 'angular-datatables';
//import {LocalStorageService, SessionStorageService, LocalStorage, SessionStorage} from 'angular-web-storage';
import { environment } from '../../../environments/environment';
import {HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {Router, ActivatedRoute} from '@angular/router';
import { User } from '../../_models/user';
import {Subject} from 'rxjs';
import { Register } from '../../_models/register';
import * as _ from "lodash";
import { AlertService } from '../../_services/alert.service';
import { OrderLine } from '../../_models/orderLine';

@Component({
  selector: 'app-track-out-bound-orders',
  templateUrl: './track-out-bound-orders.component.html',
  styleUrls: ['./track-out-bound-orders.component.scss'],
})
export class TrackOutBoundOrdersComponent implements OnInit {
  stockEntryHeader: any;
  values: number;
  getTrackOrderData: any;
  trackingNumber: any;
  shippingOption: any;
  order: any;
  returnReasons: any;
   reasonsList: any = [];
   returnOrderlines: any = [];
  invalidProductNoEntryError: string[];
  reason: string;
  customerSupport: boolean = false;
  return: boolean = false;
  displayCancelOrder : String = 'N';
  displayCustomerDisplay : String = 'N';
  displayCreateOrder : String = 'N';
  subject: any;
  description: any;
  orderLines : OrderLine[] = [];
  orders : any;
  returnType : string;
  reasonError: string;
  selectReasonError : string;
  orderLine: any = {};
  quantityError: string;
  quantity : any;
  meta : any;

  constructor(private alertService: AlertService, private http: HttpClient, private router: Router, public route: ActivatedRoute, private api: ApiIntegration, private g: Globals, public user: User, public register: Register) {
   this.getApi();
  }
  getApi(){
  this.invalidProductNoEntryError = [];
    this.g.loaderDisplay = "";
    this.api.getOrderDataByIdPublic(this.route.snapshot.params['id'], this.route.snapshot.params['jhiUserId'],"1").subscribe((data: any) => {
        this.order = data;
        this.orderLines = _.cloneDeep(this.order.lines);
        this.orders = _.cloneDeep(this.orderLines);
         this.getReasons();
        this.g.loaderDisplay = "";
        let index = 0;
        this.orderLines.forEach((d) => {
        d["previousQuantity"] = d.quantity;
        this.invalidProductNoEntryError[index++]="";
        });
        this.g.loaderDisplay = "";

        this.trackingNumber = data.trackingNumbers;
        this.shippingOption = data.shippingOption;
        this.trackOrder();
        this.g.loaderDisplay = "";
    }, err => {
        console.log(err);
        this.g.loaderDisplay = "";
    });
  }

  displayRoute(){
  document.getElementById('div3').classList.add("d-none");
                document.getElementById('div4').classList.add("d-none");
                document.getElementById('div1').classList.remove("d-none");
  }
  cancelOrderDisplayDisplay(){
              document.getElementById('div1').classList.add("d-none");
              document.getElementById('div4').classList.add("d-none");
               document.getElementById('div3').classList.remove("d-none");
               this.getReasons();
  }
  CustomerSupportDisplay(){
              document.getElementById('div1').classList.add("d-none");
              document.getElementById('div3').classList.add("d-none");
                 document.getElementById('div4').classList.remove("d-none");
  }
  CSDisplay() {
    let x = document.getElementById("csorder");
    if (x.style.display === "none") {
      x.style.display = "block";
      this.customerSupport = true;
    } else {
      x.style.display = "none";
      this.customerSupport = false;
    }
  }
  ReturnOrder() {
  this.getReasons();
    let x = document.getElementById("re-order");
    if (x.style.display === "none") {
      x.style.display = "block";
      this.return = true;
    } else {
      x.style.display = "none";
      this.return = false;
    }
  }
  ngOnInit() {
  }

  trackOrder() {
    this.g.loaderDisplay = "";
    this.api.trackOrderForShiftAggregator(this.shippingOption, this.order.orderHeaderId,this.order.orderType,this.trackingNumber).subscribe((data: any) => {
      this.getTrackOrderData = data.trackOrder;
      this.g.loaderDisplay = "";
    }, err => {
      console.log(err);
      this.g.loaderDisplay = "";
    });
  }

  getReasons(){
    this.api.getValues("1", 'RETURNORDER', 'RETURN_REASON', 'RETURN_REASON').subscribe((data: any) => {
              this.returnReasons = data.tripleSetConfigDTOS;
            }, err => {
              console.log(err);
            });
        }

 Submit(){
 this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
      this.http.post(environment.apiUrl + 'api/createReturnOrders',  {
      "accountOwnerContactId": this.order.accountOwnerCustomerId,
      "accountOwnerId": this.order.accountOwnerId,
      "additionalInfo": this.order.additionalInfo,
      "lines": this.orderLines,
      "awbNumber": this.order.awbNumber,
      "connectionName": this.order.connectionName,
      "deliveryInstructions": this.order.deliveryInstructions,
      "externalOrderId": this.order.sourceOrderId || '',
      "externalShipmentId": "string",
      //"inProcessDate": "2020-10-01T02:22:36.391Z",
      "orderNumber": this.order.orderNumber,
      "orderStatus": "SUBMITTED",
      "orderType": this.order.orderType,
      "organizationId": 1,
      "originalOrderDate": this.order.createdDate,
      "originalOrderHeaderId": this.order.orderHeaderId,
      "pickupAddressId": 0,
      "productConfig": this.order.productConfig,
      "providerStatus": this.order.providerStatus,
      "receivedDate": "2020-10-01T02:22:36.392Z",
      "referenceOrderId": "string",
      "returnOrderDate": "string",
      "returnOrderHeaderId": 0,
      "returnReason": this.reason,
      //"shipmentPrice": 0,
      "shippingMethod": this.order.shippingMethod,
      "shippingOption": this.order.shippingOption,
      "sourceOrderDate": this.order.sourceOrderDate,
      //"sourceType": "string",
      //"trackingNumber": this.order.trackingNumber,
      "warehouseId": this.order.warehouseId
    },
        {headers: header1}).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
             this.alertService.success('Order','Return Successfully');
             this.getApi();
        }
        else{
                 this.alertService.error('Error',data['message']);
                 }
        },
        (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        });
    }

      supportTicketCreate() {
          var header1 = new HttpHeaders();
             header1 = header1.append('Content-Type', 'application/json');
             header1 = header1.append('Accept', 'application/json');
             header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
             this.http.post(environment.apiUrl + 'api/createSupportTicket', {
              "accountOwnerId": this.order.accountOwnerId,
              "category": "Fulfilment Related",
              "description": this.description,
              "organizationId": this.user.organizationId,
              "subject": this.subject,
              "userId": this.user.userId
            },
            {headers: header1}).subscribe(data => {
            this.g.loaderDisplay = "";
                if (data['code'] == 200) {
                  this.alertService.success('Ticket','Created Successfully');
                  this.getApi();
                }
            },
          (err) => {
            this.g.loaderDisplay = "";
            this.alertService.error('Error',err);
          });
      }


      onFullReturn(){
      this.returnType="FullReturn";
      this.selectReasonError="";
      }


      onPartialReturn(){
      this.returnType="PartialReturn";
      this.selectReasonError="";
      }

      checkError() {
          this.reasonError = "";
          if (!this.order.returnReason) {
            this.reasonError = "Please select reason";
          }
        }

         onKey(event: any,orderLine:OrderLine,index:number) {
              this.values = Number(event.target.value);
              console.log(this.values + 1);
              if(orderLine["previousQuantity"] == 1 || (this.values > 0 && this.values <= orderLine?.previousQuantity)){
               this.invalidProductNoEntryError[index] = "";
              }else if(this.values <= 0){
                   this.invalidProductNoEntryError[index] = "Inventory should be more than Zero"
              } else {
                   this.invalidProductNoEntryError[index] = "Inventory cannot be more than ordered Quantity"
              }
            }

             removeProduct(rp) {
                let index = this.orderLines.indexOf(rp);
                this.orderLines.splice(index, 1);
              }


submitReturn() {
             let encoded = encodeURI(this.order.ordNumberEN);
             if(this.returnType == "PartialReturn"){
                     for(let ol of this.orderLines){
                       this.orderLine.orderLineId= ol.orderLineId;
                       this.orderLine.returnQuantity = ol.quantity;
                       this.returnOrderlines.push(_.cloneDeep(this.orderLine));
                       }
                        }else {
                           for(let o of this.orders){
                              this.orderLine.orderLineId= o.orderLineId;
                               this.orderLine.returnQuantity = o.quantity;
                               this.returnOrderlines.push(_.cloneDeep(this.orderLine));
                               }
                               }
    this.quantityError = "";
    this.selectReasonError = "";
    for (let sl of this.orderLines) {
      if (
        !sl.quantity ||
        sl.quantity === null ||
        sl.quantity === undefined ||
        (!sl.previousQuantity && sl.quantity <= 0) ||
        (sl.previousQuantity &&
          (sl.previousQuantity < sl.quantity || sl.quantity <= 0))
      ) {
        this.quantityError =
          "Please enter quantity as minimum 1 and maximum previous quantity";
      }
    }
    if (!this.orderLines.length) {
      this.quantityError = "Atleast one product is need to return order";
    }
    if (!this.order.returnReason) {
      this.selectReasonError = "Please select reason";
    }
    if (this.selectReasonError || this.quantityError) {
      return;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl + "api/public/orders/"+ encoded +"/return-orders",
        {
/*        accountOwnerContactId: this.order.accountOwnerCustomerId,
          additionalInfo: this.order.additionalInfo,
          lines: this.orderLines,
          awbNumber: this.order.awbNumber,
          connectionName: this.order.connectionName,
          deliveryInstructions: this.order.deliveryInstructions,
          externalOrderId: this.order.sourceOrderId || "",
          externalShipmentId: "string",
          //"inProcessDate": "2020-10-01T02:22:36.391Z",
          originalOrderDate: this.order.createdDate,
          originalOrderHeaderId: this.order.orderHeaderId,
          pickupAddressId: 0,
          productConfig: this.order.productConfig,
          providerStatus: this.order.providerStatus,
          receivedDate: "2020-10-01T02:22:36.392Z",
          referenceOrderId: "string",
          returnOrderDate: "string",
          returnOrderHeaderId: 0,
          shipmentPrice: 0,
          shippingMethod: this.order.shippingMethod,
          shippingOption: this.order.shippingOption,
          sourceOrderDate: this.order.sourceOrderDate,
          sourceType: "string",
          trackingNumber: this.order.trackingNumber,
          warehouseId: this.order.warehouseId,
          "orderNumber": this.order.orderNumber,
          "accountOwnerId": this.order.accountOwnerId,
          "destPincode": this.order.pickupAreaPinCode,
          "originPincode": this.order.deliveryAreaPinCode,
          "orderStatus": "SUBMITTED",
          "orderType": this.order.orderType,
          "returnReason": this.order.returnReason,*/
          "organizationId": 1,
          "accountOwnerId": this.order.accountOwnerId,
          "returnReason" : this.order.returnReason,
          "orderLines": this.returnOrderlines,
          "orderStatus":"RETURN",
          /* "shippingDetails": details,
          "dimensions":dimensions, */
        },
        { headers: header1 }
      )
      .subscribe(
        (data : any) => {
          this.g.loaderDisplay = "";
          if (data["code"] == 200) {
          this.returnOrderlines =[];
            this.alertService.success("Order", "Return Successfully");
          }else{
          this.g.loaderDisplay = "";
          this.alertService.error("Error", data["message"]);
          }
        },
        (err) => {
        this.returnOrderlines =[];
          this.g.loaderDisplay = "";
          this.alertService.error("Error", err);
        }
      );
  }

        typeError(){
      this.selectReasonError='';
      if(this.order.returnReason==null || this.order.returnReason == undefined || this.order.returnReason=="" ){
      this.selectReasonError = "Please select the Reason";
      }}
}
